import * as React from 'react';
import './PrimaryNav.css';
import { ProfileNavClick } from '../../../store/action/primaryNavActions';
import { DELTA, GENERAL, PROFILE, RESULTS } from '../../../store/constants';
import NavItem from './NavItem';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight }  from '@fortawesome/fontawesome-free-solid';
import SectionIndicator from './SectionIndicator';

interface Props {
    loading: boolean;
    navId: string;
    profileValid: boolean;
    generalValid: boolean;
    deltaDisabled: boolean;
    resultsDisabled: boolean;
    deltaValid: boolean;
    profileNavClick: ProfileNavClick;
    generalNavClick: ProfileNavClick;
    deltaNavClick: ProfileNavClick;
    resultsNavClick: ProfileNavClick;
}

function ArrowIcon () {
    return (
        <FontAwesomeIcon
            className="arrow-icon"
            icon={faLongArrowAltRight}
            color="#E5E5E5"
        />
    );
}

class PrimaryNav extends React.Component<Props> {
    render() {
        const {
            profileNavClick,
            generalNavClick,
            deltaNavClick,
            resultsNavClick,
            navId,
            profileValid,
            generalValid,
            deltaValid,
            deltaDisabled,
            resultsDisabled,
        } = this.props;

        return (
            <nav>
                <ul className="nav-items nav-flex-container">
                    <NavItem
                        onClick={(id) => profileNavClick(id, profileValid)}
                        disabled={!profileValid}
                        activeId={navId}
                        id={PROFILE}
                    >
                        <SectionIndicator
                            sectionNumber={1}
                            completed={profileValid}
                        />
                        <span className="nav-item-text">Profile</span>
                        <ArrowIcon />
                    </NavItem>
                    <NavItem
                        onClick={(id) => generalNavClick(id, profileValid)}
                        disabled={!profileValid}
                        activeId={navId}
                        id={GENERAL}
                    >
                        <SectionIndicator
                            sectionNumber={2}
                            completed={generalValid}
                        />
                        <span className="nav-item-text">General</span>
                        <ArrowIcon />
                    </NavItem>
                    <NavItem
                        onClick={(id) => deltaNavClick(id, deltaDisabled)}
                        disabled={!generalValid}
                        activeId={navId}
                        id={DELTA}
                    >
                        <SectionIndicator
                            sectionNumber={3}
                            completed={deltaValid}
                        />
                        <span className="nav-item-text">Delta</span>
                        <ArrowIcon />
                    </NavItem>
                    <NavItem
                        onClick={(id) => resultsNavClick(id, resultsDisabled)}
                        disabled={resultsDisabled}
                        activeId={navId}
                        id={RESULTS}
                    >
                        <SectionIndicator
                            sectionNumber={4}
                            completed={false}
                        />
                        <span className="nav-item-text">Results</span>
                    </NavItem>
                </ul>
            </nav>
        );
    }
}

export default PrimaryNav;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/nav/topNav/PrimaryNav.tsx